import type { TokenUsageModelOption, TokenUsageSummary } from '../types/api'
import { apiClient } from './client'

export async function getTokenUsage(days = 30, model?: string): Promise<TokenUsageSummary> {
  const params = new URLSearchParams({ days: String(days) })
  if (model) params.set('model', model)
  return apiClient.get<TokenUsageSummary>(`/token-usage?${params}`)
}

export async function getTokenUsageModels(): Promise<TokenUsageModelOption[]> {
  const res = await apiClient.get<{ models: TokenUsageModelOption[] }>('/token-usage/models')
  return res.models
}

/** Token-usage Time Period presets — same labels as the token-savings tab. */
export const TOKEN_USAGE_PERIODS = [
  { label: 'Last 24 hours', days: 1 },
  { label: 'Last 7 days', days: 7 },
  { label: 'Last 30 days', days: 30 },
  { label: 'Last 12 months', days: 365 },
] as const

export async function getAdminTokenUsage(days = 30): Promise<TokenUsageSummary[]> {
  return apiClient.get<TokenUsageSummary[]>(`/admin/token-usage?days=${days}`)
}
